export default __webpack_public_path__ + "static/media/tarde-off.f78593cd.svg";